<!--Copyright Laserfiche.-->

<span class="lf-text-label">{{ TAGS }}</span>
<mat-form-field class="tag-list" appearance="outline">
  <mat-chip-grid #chipGrid class="chip-list">
    @for (tag of selectedTagDefinitions; track tag; let i = $index) {
      <mat-chip-row #chip (keydown)="onChipKeyDown($event, i)" (removed)="remove(tag)" tabindex="0">
        {{ tag.displayName }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <input
    matInput
    #tagInput
    [formControl]="tagCtrl"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipGrid"
    placeholder="+ {{ selectedTagDefinitions.length === 0 ? ADD_TAGS : ADD_MORE_TAGS }}"
  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (tag of filteredTags; track tag) {
      <mat-option [value]="tag">
        <mat-chip>{{ tag.displayName }}</mat-chip>
      </mat-option>
    }
    @if (filteredTags.length === 0) {
      <mat-option disabled class="no-more-tags">
        {{ NO_TAGS_AVAILABLE }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
